module.exports = __webpack_public_path__ + "nc_static/media/user-preferences.708124e6.svg";